<template>
  <div class="c-productText" :style="{backgroundColor: content.bgColor}">
    <div class="c-standard">
      <div class="c-productText__content">
        <div class="c-productText__des">
          <p>{{ content.description }}</p>
        </div>
        <div class="c-productText__items">
          <div class="c-productText__item" v-for="(item, index) in content.items" :key="index">
            <h4 class="title_h4">{{ item.title }}</h4>
            <p>{{ item.content }}</p>
          </div>
        </div>
      </div>
      <div class="c-productText__imgs">
        <div class="c-productText__img" v-for="(x, y) in content.imgs" :key="y" :style="{backgroundImage:'url('+ x.img +')'}">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'productText',
    props: ['content'],
    data(){
      return{

      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
